import { Flex, Image } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import Text from 'components/_core/Text';

interface WorkListEmptyViewProps {
  imageSrc: string;
  title: string;
  description?: string;
}

const WorkListEmptyView: FCWithChildren<WorkListEmptyViewProps> = ({
  children,
  description,
  imageSrc,
  title,
}) => (
  <Flex alignItems="center" direction="column" paddingY="space-32">
    <Image
      alt=""
      height="90px"
      marginBottom="space-6"
      role="presentation"
      src={imageSrc}
      width="90px"
    />

    <Text
      fontWeight="weight-500"
      marginBottom="space-4"
      size="lg"
      variant="primary"
    >
      {title}
    </Text>

    {description ? (
      <Text size="sm" textAlign="center" variant="secondary">
        {description}
      </Text>
    ) : null}

    {children}
  </Flex>
);

export default WorkListEmptyView;
